import { Environment } from './environment.model';

/** Env d'un équipement tel que stocké côté backend (`trackers.env`, `gateways.env`). */
export type DeviceEnv = 'dev' | 'qualif' | 'preprod' | 'prod';

const DEVICE_ENV_BY_APP_TYPE: Partial<Record<Environment['type'], DeviceEnv>> = {
  local: 'dev',
  develop: 'dev',
  qualif: 'qualif',
  preprod: 'preprod',
  'preprod-rom': 'preprod',
  'v3-preprod': 'preprod',
  production: 'prod',
};

/**
 * Env des équipements de l'environnement courant (ADR-015) : `environment.type` du build inside →
 * valeur `env` des équipements. Sert de filtre par défaut aux listes Trackers / Gateways.
 * Type inconnu ou sans correspondance : `undefined` (aucun filtre).
 */
export function deviceEnvForAppType(type: string | null | undefined): DeviceEnv | undefined {
  return type ? DEVICE_ENV_BY_APP_TYPE[type as Environment['type']] : undefined;
}
